import type { Setup } from '~/types/system'
import { defineStore } from 'pinia'

// https://masteringpinia.com/blog/top-5-mistakes-to-avoid-when-using-pinia
// https://pinia.vuejs.org/ssr/nuxt.html

export interface ReportForm {
  ds_caption: string
  cd_form: string | number
}

export const useSystemStore = defineStore('system', () => {
  const setup = ref<Setup>()
  const icon = ref(null)

  const sEditor = ref(0)
  const sSelecao = ref('')
  const sModelo = ref(0)
  const sViewer = ref('')
  // Modal stack (internal): needed for nested modals (e.g. confirmation over form).
  const modalStack = ref<string[]>([])

  const loadLogo = async () => {
    if (icon.value) return icon.value
    try {
      const response = await useHttpApi('/setup/logo')
      icon.value = await useFileDownload().blobToBase64(response as Blob)
      if ((response as Blob).size > 200 * 1024)
        console.warn(`Tamanho do logo: ${((response as Blob).size / 1024).toFixed(0)}KB`)
      return icon.value
    } catch (error) {
      console.log(error)
      return null
    }
  }

  const loadSetup = async () => {
    try {
      const response = await useHttpApi('/setup/data') as Setup[]
      setup.value = response?.length ? response[0] : {} as Setup
      setup.value!.nr_portal = '3092.9'
    } catch (error) {
      console.log(error)
    }
  }

  // const loadMenu = async () => {
  //   try {
  //     return await useHttpApi('/menu/main')
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  const loadReport = async (): Promise<ReportForm[]> => {
    try {
      return await useHttpApi('/menu/report')
    } catch (error) {
      console.log(error)
    }
  }

  function $reset() {
    setup.value = {} as Setup
    icon.value = null
    setEditor({})
  }

  function setEditor(value?: { exame?: number, selecao?: string, modelo?: number }) {
    sEditor.value = value?.exame ?? null
    sSelecao.value = value?.selecao ?? null
    sModelo.value = value?.modelo ?? null
  }

  const pushModal = (id: string) => modalStack.value = modalStack.value.filter(x => x !== id).concat(id)
  const popModal = (id: string) => modalStack.value = modalStack.value.filter(x => x !== id)
  const isTopModal = (id: string) => topModalId.value === id
  const getModal = (): string => `Modal-${Math.random().toString(36).slice(2)}`
  const topModalId = computed(() => modalStack.value[modalStack.value.length - 1] ?? null)
  const hasModalOpen = computed(() => modalStack.value.length > 0)

  return {
    sEditor,
    sViewer,
    sSelecao,
    sModelo,
    setup,
    icon,
    setEditor,
    pushModal,
    popModal,
    isTopModal,
    hasModalOpen,
    getModal,
    $reset,
    loadSetup,
    loadReport,
    loadLogo
  }
}, {
  persist: {
    storage: typeof window !== 'undefined' ? localStorage : undefined,
    pick: ['sEditor', 'sSelecao', 'sModelo', 'setup', 'icon', 'sViewer']
  }
})
